import { defineCustomElements } from 'ionicons/dist/loader';
// Register Ionicons web component globally
defineCustomElements(window);
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi, HttpClient } from '@angular/common/http';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { provideAppInitializer, inject } from '@angular/core';
import { provideHighcharts } from 'highcharts-angular';
import * as Highcharts from 'highcharts';
import { authInterceptor } from './app/shared/interceptors/auth.interceptor';
import { CustomTranslateLoader } from './app/shared/helpers/custom-translate-loader';
import { TranslationService } from './app/shared/services/translation.service';
import { WizardBrandingService } from './app/pages/wizards/wizard-branding.service';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';

export const getCurrentLanguage = () => {
  return localStorage.getItem('language') || 'en';
};

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new CustomTranslateLoader(httpClient);
}

bootstrapApplication(AppComponent, {
  providers: [
    provideAnimations(),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(
      withInterceptors([authInterceptor]),
      withInterceptorsFromDi()
    ),
    provideTranslateService({
      defaultLanguage: getCurrentLanguage(),
      fallbackLang: getCurrentLanguage(),
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      }
    }),
    provideAppInitializer(() => {
      const translationService = inject(TranslationService);
      return translationService.initialize();
    }),
    provideAppInitializer(() => {
      const wizardBrandingService = inject(WizardBrandingService);
      if (typeof window !== 'undefined') {
        const url = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        wizardBrandingService.setActiveBrandingFromUrl(url);
      }
    }),
    provideHighcharts({
      instance: () => Promise.resolve(Highcharts),
    }),
  ],
});
